<template>
  <events-list-page-layout :url-filter-keys="urlFilterKeys"
                           :allowed-advanced-filters="allowedAdvancedFilters"
                           :filter-options="filterOptions"
                           :page-title="i18n.t('activerecord.models.event.other')">
    <template #title>
      <h2>{{ i18n.t('activerecord.models.event.other') }}</h2>
    </template>
    <template #share-buttons>
      <social-share-buttons :channels="socialSharing.channels" entity-type="hub" :utm-medium="socialSharing.utmMedium"
                            class="mt-3" />
    </template>
    <template #stats>
      <div>
        <stat-with-icon icon-class="icon-star" :number="totalEventsCount" label-i18n-key="upcoming" />
      </div>
    </template>
  </events-list-page-layout>
</template>

<script>
import EventsListPageLayout from './events-list-page-layout'
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import { sharedMapPropsMixin } from './shared-map-props'
import SocialShareButtons from '@/share/current-page/social-share-buttons'
import {
  FILTER_KEY_CALENDARS,
  FILTER_KEY_EVENT_TYPES,
  FILTER_KEY_INCLUDE_VIRTUAL,
  FILTER_KEY_LABELS,
  FILTER_KEY_LOCATION,
  FILTER_KEY_REGIONS,
  FILTER_KEY_START_DATE_RANGE,
  FILTER_KEY_UPCOMING_ONLY
} from './filter-keys'
import StatWithIcon from '../stats/stat-with-icon'

export default {
  components: { EventsListPageLayout, StatWithIcon, SocialShareButtons },

  mixins: [ GeoipCountryMixin, sharedMapPropsMixin ],

  props: {
    filterOptions: {
      type: Object,
      required: true
    },
    showEventTypeFilter: {
      type: Boolean,
      required: true
    },
    showLabelFilter: {
      type: Boolean,
      required: true
    },
    showRegionFilter: {
      type: Boolean,
      required: true
    },
    socialSharing: {
      type: Object,
      required: true
    },
    totalEventsCount: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      urlFilterKeys: [FILTER_KEY_CALENDARS, FILTER_KEY_EVENT_TYPES, FILTER_KEY_INCLUDE_VIRTUAL, FILTER_KEY_LABELS,
                      FILTER_KEY_LOCATION, FILTER_KEY_REGIONS, FILTER_KEY_START_DATE_RANGE, FILTER_KEY_UPCOMING_ONLY]
    }
  },

  computed: {
    allowedAdvancedFilters() {
      const allowed = [FILTER_KEY_INCLUDE_VIRTUAL, FILTER_KEY_START_DATE_RANGE]

      if (this.showEventTypeFilter) {
        allowed.push(FILTER_KEY_EVENT_TYPES)
      }

      if (this.showLabelFilter) {
        allowed.push(FILTER_KEY_LABELS)
      }

      if (this.showRegionFilter) {
        allowed.push(FILTER_KEY_REGIONS)
      }

      return allowed
    }
  },

  created() {
    this.$store.commit('setEventCreationAllowed', !this.agraConfiguration.disablePublicEventCreation)
  }
}
</script>
